import React from 'react';
import { FadeIn } from '../components/ui/FadeIn';
import { Button } from '../components/ui/Button';
import { SectionHeading } from '../components/ui/SectionHeading';
export function Home() {
  return <div className="bg-ivory" data-id="element-284">
      {/* Hero Section */}
      <section className="relative h-screen min-h-[600px] flex items-center justify-center overflow-hidden" data-id="element-285">
        <div className="absolute inset-0 z-0" data-id="element-286">
          <img src="https://cdn.magicpatterns.com/uploads/5xFT8GxDZ5RZpDs6Rv7zqu/2.png" alt="Makeup artist applying bridal makeup on-site" className="w-full h-full object-cover object-center" data-id="element-287" />
          <div className="absolute inset-0 bg-espresso/40 mix-blend-multiply" data-id="element-288" />
        </div>

        <div className="relative z-10 text-center px-6 max-w-4xl mx-auto mt-20" data-id="element-289">
          <FadeIn delay={0.2} data-id="element-290">
            <h1 className="text-5xl md:text-7xl text-ivory mb-6 text-balance" data-id="element-291">
              Luxury Bridal Beauty, Brought to You
            </h1>
          </FadeIn>
          <FadeIn delay={0.4} data-id="element-292">
            <p className="text-lg md:text-xl text-cream font-light mb-4 text-balance leading-relaxed" data-id="element-293">
              Refined on-site makeup artistry, brow design, skin rituals, and
              elevated beauty services for brides and women who desire elegance,
              ease, and intentional care.
            </p>
            <p className="text-sm tracking-[0.2em] uppercase text-champagne mb-10" data-id="element-294">
              Now booking in Charlotte, NC.
            </p>
          </FadeIn>
          <FadeIn delay={0.6} className="flex flex-col sm:flex-row items-center justify-center gap-4" data-id="element-295">
            <Button href="/bridal-services" variant="primary" className="w-full sm:w-auto bg-ivory text-espresso hover:bg-cream" data-id="element-296">
              Explore Services
            </Button>
            <Button href="/contact" variant="outline" className="w-full sm:w-auto border-ivory text-ivory hover:bg-ivory hover:text-espresso" data-id="element-297">
              Inquire to Book
            </Button>
          </FadeIn>
        </div>
      </section>

      {/* Brand Intro Section */}
      <section className="py-24 md:py-32 px-6" data-id="element-298">
        <div className="max-w-3xl mx-auto text-center" data-id="element-299">
          <FadeIn data-id="element-300">
            <SectionHeading kicker="Our Approach" title="Elevated Beauty, Thoughtfully Curated" data-id="element-301" />
            <p className="text-lg md:text-xl text-taupe font-light leading-relaxed mt-8" data-id="element-302">
              At Aura Beauty Atelier, beauty is approached with softness,
              precision, and intention. We create elevated on-site experiences
              for brides and women who value polished artistry, calm luxury, and
              thoughtful care. From wedding mornings to special occasions and
              signature beauty appointments, each service is designed to feel
              seamless, refined, and beautifully personal.
            </p>
          </FadeIn>
        </div>
      </section>

      {/* Bridal Services Preview Section */}
      <section className="py-24 bg-cream px-6" data-id="element-303">
        <div className="max-w-7xl mx-auto" data-id="element-304">
          <FadeIn data-id="element-305">
            <div className="flex flex-col md:flex-row md:items-end justify-between mb-16 gap-8" data-id="element-306">
              <SectionHeading title="The Bridal Experience" subtitle="Curated beauty for the most meaningful moments." centered={false} className="mb-0" data-id="element-307" />
              <Button href="/bridal-services" variant="outline" data-id="element-308">
                View Bridal Experiences
              </Button>
            </div>
          </FadeIn>

          <div className="grid grid-cols-2 md:grid-cols-3 gap-x-8 gap-y-12" data-id="element-309">
            {['Bridal Makeup', 'Makeup Trials', 'Brow Design', 'Bridal Glow Facial', 'Luxury Touch-Up Kit', 'Bridal Renewal Massage'].map((service, i) => <FadeIn key={service} delay={i * 0.1} className="flex flex-col items-center text-center group" data-id="element-310">
                <div className="w-full aspect-[4/5] mb-6 overflow-hidden bg-warm-beige/20" data-id="element-311">
                  <img src={['https://cdn.magicpatterns.com/uploads/ssoSwGeuZuFUPuP1TkZQ5H/1.jpg', 'https://cdn.magicpatterns.com/uploads/hxLQFprSYGixS18uzWj1vf/1.png', 'https://cdn.magicpatterns.com/uploads/oP3Saohzq7UpmDF79EcJVs/3.png', 'https://cdn.magicpatterns.com/uploads/kdbRKXWT9GFz3b6hRZNfuW/4.png', 'https://cdn.magicpatterns.com/uploads/sfhEXTfkMSvXbkSdEpf7Ta/5.png', 'https://cdn.magicpatterns.com/uploads/6rpzus7csd7BkdKKABzNM4/6.png'][i]} alt={service} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" data-id="element-312" />
                </div>
                <h3 className="text-xl text-espresso" data-id="element-313">{service}</h3>
              </FadeIn>)}
          </div>
        </div>
      </section>

      {/* Bridal Packages Preview Section */}
      <section className="py-24 md:py-32 px-6" data-id="element-314">
        <div className="max-w-7xl mx-auto" data-id="element-315">
          <FadeIn data-id="element-316">
            <SectionHeading kicker="Investments" title="Bridal Beauty Experiences" data-id="element-317" />
          </FadeIn>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mt-16 items-center" data-id="element-318">
            {/* Card 1 */}
            <FadeIn delay={0.1} className="bg-white p-10 border border-champagne/50 flex flex-col h-full" data-id="element-319">
              <h3 className="text-2xl mb-2" data-id="element-320">The Signature Bride Experience</h3>
              <p className="text-sm tracking-widest text-gold uppercase mb-6" data-id="element-321">
                Investment $470
              </p>
              <p className="text-taupe font-light mb-8 flex-grow" data-id="element-322">
                A refined bridal beauty essential for the modern bride.
              </p>
              <div className="w-full h-[1px] bg-champagne/50 mb-8" data-id="element-323" />
              <Button href="/bridal-services" variant="ghost" className="self-start px-0" data-id="element-324">
                View Details
              </Button>
            </FadeIn>

            {/* Card 2 - Prominent */}
            <FadeIn delay={0.2} className="bg-espresso text-ivory p-12 border border-gold relative md:scale-105 shadow-xl flex flex-col h-full z-10" data-id="element-325">
              <div className="absolute top-0 left-1/2 -translate-x-1/2 -translate-y-1/2 bg-gold text-white text-[0.65rem] tracking-[0.2em] uppercase px-4 py-1" data-id="element-326">
                Most Loved
              </div>
              <h3 className="text-3xl mb-2" data-id="element-327">
                The Luxury Bridal Glow Experience
              </h3>
              <p className="text-sm tracking-widest text-champagne uppercase mb-6" data-id="element-328">
                Investment $620
              </p>
              <p className="text-cream font-light mb-8 flex-grow" data-id="element-329">
                Radiant skin, elevated preparation, and a beautifully polished
                finish.
              </p>
              <div className="w-full h-[1px] bg-taupe/50 mb-8" data-id="element-330" />
              <Button href="/bridal-services" variant="primary" className="bg-ivory text-espresso hover:bg-cream w-full" data-id="element-331">
                View Details
              </Button>
            </FadeIn>

            {/* Card 3 */}
            <FadeIn delay={0.3} className="bg-white p-10 border border-champagne/50 flex flex-col h-full" data-id="element-332">
              <h3 className="text-2xl mb-2" data-id="element-333">
                The Ultimate VIP Bride Experience
              </h3>
              <p className="text-sm tracking-widest text-gold uppercase mb-6" data-id="element-334">
                Investment $740
              </p>
              <p className="text-taupe font-light mb-8 flex-grow" data-id="element-335">
                A complete luxury beauty ritual for the bride who desires the
                full Aura experience.
              </p>
              <div className="w-full h-[1px] bg-champagne/50 mb-8" data-id="element-336" />
              <Button href="/bridal-services" variant="ghost" className="self-start px-0" data-id="element-337">
                View Details
              </Button>
            </FadeIn>
          </div>

          <FadeIn delay={0.4} className="mt-16 text-center" data-id="element-338">
            <Button href="/bridal-services" variant="outline" data-id="element-339">
              View Full Bridal Details
            </Button>
          </FadeIn>
        </div>
      </section>

      {/* Signature Beauty Services Preview Section */}
      <section className="py-24 bg-warm-beige/10 px-6" data-id="element-340">
        <div className="max-w-4xl mx-auto" data-id="element-341">
          <FadeIn data-id="element-342">
            <SectionHeading title="Signature Beauty Services" subtitle="A curated collection of on-site beauty services designed for polished, effortless elegance." data-id="element-343" />
          </FadeIn>

          <div className="mt-16 flex flex-col gap-6" data-id="element-344">
            {[{
            name: 'Brow Design',
            price: '$35'
          }, {
            name: 'Korean Lash Lift',
            price: '$85'
          }, {
            name: 'Custom Glow Facial',
            price: '$95'
          }, {
            name: 'Social Makeup',
            price: '$165'
          }, {
            name: 'PMU Brow',
            price: '$299'
          }].map((service, i) => <FadeIn key={service.name} delay={i * 0.1} data-id="element-345">
                <div className="flex items-center justify-between py-4 border-b border-champagne" data-id="element-346">
                  <h4 className="text-xl md:text-2xl text-espresso" data-id="element-347">
                    {service.name}
                  </h4>
                  <span className="text-lg text-taupe font-light" data-id="element-348">
                    {service.price}
                  </span>
                </div>
              </FadeIn>)}
          </div>

          <FadeIn delay={0.6} className="mt-16 text-center" data-id="element-349">
            <Button href="/beauty-services" variant="primary" data-id="element-350">
              Explore Beauty Services
            </Button>
          </FadeIn>
        </div>
      </section>

      {/* Reviews Section */}
      <section className="py-24 md:py-32 px-6" data-id="element-351">
        <div className="max-w-7xl mx-auto" data-id="element-352">
          <FadeIn data-id="element-353">
            <SectionHeading kicker="Testimonials" title="Kind Words" subtitle="Loved for the experience. Remembered for the results." data-id="element-354" />
            <p className="text-center text-taupe font-light max-w-2xl mx-auto mt-6" data-id="element-355">
              Our clients value more than beautiful makeup — they value the
              calm, care, and elevated experience behind it.
            </p>
          </FadeIn>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mt-16" data-id="element-356">
            {['Aura made me feel so beautiful, confident, and cared for. The entire experience felt calm, luxurious, and so personal from beginning to end.', 'My makeup was flawless, soft, and elegant exactly how I envisioned it. The convenience of on-site service made everything feel effortless.', 'From brows to skin prep to wedding day glam, every detail felt intentional and elevated. Truly a beautiful experience.'].map((quote, i) => <FadeIn key={i} delay={i * 0.2} className="bg-cream p-10 text-center flex flex-col items-center" data-id="element-357">
                <div className="flex gap-1 mb-6 text-gold" data-id="element-358">
                  {[...Array(5)].map((_, j) => <svg key={j} className="w-4 h-4 fill-current" viewBox="0 0 20 20" data-id="element-359">
                      <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" data-id="element-360" />
                    </svg>)}
                </div>
                <p className="text-espresso font-serif text-xl italic leading-relaxed" data-id="element-361">
                  "{quote}"
                </p>
              </FadeIn>)}
          </div>
        </div>
      </section>

      {/* On-Site Experience Section */}
      <section className="py-24 bg-espresso text-ivory px-6 relative overflow-hidden" data-id="element-362">
        <div className="absolute inset-0 opacity-20" data-id="element-363">
          <img src="https://cdn.magicpatterns.com/uploads/1EtCQLivbusJnA8N7iZoTW/1.png" alt="Makeup artist providing on-site bridal beauty service" className="w-full h-full object-cover" data-id="element-364" />
        </div>
        <div className="max-w-3xl mx-auto text-center relative z-10" data-id="element-365">
          <FadeIn data-id="element-366">
            <SectionHeading title="Beauty, Wherever You Are" light data-id="element-367" />
            <p className="text-lg md:text-xl text-cream font-light leading-relaxed mt-8" data-id="element-368">
              Aura Beauty Atelier offers luxury on-site services throughout
              Charlotte, NC — bringing refined beauty directly to your home,
              hotel, bridal suite, or chosen location.
            </p>
          </FadeIn>
        </div>
      </section>

      {/* Final CTA Section */}
      <section className="py-32 px-6 text-center" data-id="element-369">
        <FadeIn data-id="element-370">
          <h2 className="text-4xl md:text-5xl font-serif text-espresso mb-6" data-id="element-371">
            Begin Your Aura Experience
          </h2>
          <p className="text-taupe text-lg mb-10" data-id="element-372">
            Luxury beauty, thoughtfully brought to you.
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4" data-id="element-373">
            <Button href="/contact" variant="primary" data-id="element-374">
              Inquire Now
            </Button>
            <Button href="/contact" variant="outline" data-id="element-375">
              Book Your Experience
            </Button>
          </div>
        </FadeIn>
      </section>
    </div>;
}